import { render } from "./DecadesExpi.vue?vue&type=template&id=b256807e&scoped=true"
import script from "./DecadesExpi.vue?vue&type=script&lang=js"
export * from "./DecadesExpi.vue?vue&type=script&lang=js"

import "./DecadesExpi.vue?vue&type=style&index=0&id=b256807e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b256807e"]])

export default __exports__